import { useState, useEffect } from 'react';
import C from 'classnames';
import * as amazonConnect from 'services/connectService';
import useUser from 'utils/useUser';
import { isReadOnlyRole } from 'utils/userTypeHelper';
import { useAppSelector } from 'store';

import type { FC } from 'react';

interface ConnectProps {
  isOpen: boolean;
  phoneNumber: string;
  patientGuid: string;
  setCallId: (callId: string) => void;
  isRpmCall: boolean;
  deviceId: string;
  readingId: string;
  windowExpanded: boolean;
}

const Connect: FC<ConnectProps> = ({
  isOpen,
  phoneNumber,
  patientGuid,
  setCallId,
  isRpmCall,
  deviceId,
  readingId,
  windowExpanded,
}) => {
  const [initialized, setInitialized] = useState(false);
  const socket = useAppSelector((state) => state.socket);
  const awsRum = useAppSelector((state) => state.awsRum);
  const { roleNames } = useUser();
  const readOnlyRole = isReadOnlyRole(roleNames);

  useEffect(() => {
    if (isOpen && !initialized) {
      amazonConnect.init(
        phoneNumber,
        patientGuid,
        setCallId,
        isRpmCall,
        deviceId,
        readingId,
        socket.client!,
        awsRum.agent,
        readOnlyRole,
      );
      setInitialized(true);
    }

    if (!isOpen && initialized) {
      amazonConnect.terminate();
      setInitialized(false);
    }
  }, [isOpen, phoneNumber]);

  return (
    <div
      className={C('connect', windowExpanded ? 'expanded' : 'collapsed')}
      id="connect-el"
    />
  );
};

export default Connect;
